import React from '../../_snowpack/pkg/react.js';

function SvgComponent() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 114 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8893 113.779C88.3085 113.779 113.779 88.3084 113.779 56.8893C113.779 25.4702 88.3085 0 56.8893 0C25.4702 0 0 25.4702 0 56.8893C0 88.3084 25.4702 113.779 56.8893 113.779Z",
    fill: "#9095A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8893 312.89C88.3085 312.89 113.779 287.42 113.779 256.001C113.779 224.582 88.3085 199.111 56.8893 199.111C25.4702 199.111 0 224.582 0 256.001C0 287.42 25.4702 312.89 56.8893 312.89Z",
    fill: "#9095A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8893 511.999C88.3085 511.999 113.779 486.529 113.779 455.11C113.779 423.691 88.3085 398.221 56.8893 398.221C25.4702 398.221 0 423.691 0 455.11C0 486.529 25.4702 511.999 56.8893 511.999Z",
    fill: "#9095A8"
  }));
}

export default SvgComponent;